(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["veil-guide-launcher"]) return;
  try {
    
(() => {
  const config = document.querySelector('.vv-guide-launcher-config');
  const label = config?.dataset.label || 'Veil Guide';
  const contactUrl = config?.dataset.contactUrl || '/pages/contact';

  const connectContactButtons = () => {
    const contactLabels = /^(contact|contact us|contact support|contact violet)$/i;

    document.querySelectorAll('a, button').forEach((element) => {
      const text = element.textContent.trim().replace(/\s+/g, ' ');
      if (!contactLabels.test(text)) return;

      if (element.tagName === 'A') {
        element.setAttribute('href', contactUrl);
        return;
      }

      if (element.dataset.vvContactButton === 'true') return;
      element.dataset.vvContactButton = 'true';
      element.addEventListener('click', () => window.location.assign(contactUrl));
    });
  };

  const customiseLauncher = () => {
    const host = document.querySelector('shopify-chat');
    const root = host?.shadowRoot;
    if (!root) return false;

    const button = root.querySelector('[part="activator"]');
    const buttonLabel = root.querySelector('.activator__label');
    if (button) button.setAttribute('aria-label', label);
    if (buttonLabel && buttonLabel.textContent !== label) buttonLabel.textContent = label;

    if (!root.querySelector('#vv-guide-launcher-style')) {
      const style = document.createElement('style');
      style.id = 'vv-guide-launcher-style';
      style.textContent = `
        .activator__label {
          color: #ffffff !important;
          -webkit-text-fill-color: #ffffff !important;
          font-family: "Segoe Script", "Brush Script MT", "Apple Chancery", cursive !important;
          font-size: 20px !important;
          font-weight: 600 !important;
        }
        .activator__icon,
        .activator__icon svg,
        .activator__icon path {
          color: #ffffff !important;
          stroke: #ffffff !important;
        }
        .activator__indicator {
          display: none !important;
        }
      `;
      root.appendChild(style);
    }

    return true;
  };

  if (!customiseLauncher()) {
    const observer = new MutationObserver(() => {
      if (customiseLauncher()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  connectContactButtons();

  const contactObserver = new MutationObserver(connectContactButtons);
  contactObserver.observe(document.body, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();
})();
